<div class="app-notification-container" *ngIf="notifications$ | async as notifications">
  <div
    class="app-notification"
    *ngFor="let n of notifications"
    [class.app-notification--success]="n.level === 'success'"
    [class.app-notification--info]="n.level === 'info'"
    [class.app-notification--warning]="n.level === 'warning'"
    [class.app-notification--error]="n.level === 'error'"
    [class.app-notification--punch]="!!n.punch"
  >
    <ng-container *ngIf="n.punch; else defaultNotification">
      <app-punch-notification-card [punch]="n.punch" [title]="n.title" (open)="onOpenPunch(n.punch)"></app-punch-notification-card>
    </ng-container>
    <ng-template #defaultNotification>
      <div class="app-notification__title" *ngIf="n.title">{{ n.title }}</div>
      <div class="app-notification__message" (click)="dismiss(n.id)" tabindex="0">{{ n.message }}</div>
    </ng-template>
  </div>
</div>
